export default {
    Metadata: {
        Name: "Trim",
        Description: "Returns the given string with empty space removed from the start and end of the string.",
        Syntax: "Trim(string)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(stringInput) {
        if (stringInput == undefined || stringInput == null) {
            return "";
        }

        if (typeof stringInput != 'string') {
            stringInput = stringInput.toString();
        }

        return stringInput.trim();
    },
};

